var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"youtube-player","frameborder":"0","allowfullscreen":"1","src":_vm.videoUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }